import Modal from "../utils/modal";

export default class CustomEvents {
    constructor(comm) {
        this.comm = comm;
        /* polyfill for CustomEvent  https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill */
        (function () {

            if ( typeof window.CustomEvent === "function" ) return false;

            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: null };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }

            window.CustomEvent = CustomEvent;
        })();
        /* end polyfill for CustomEvents */
    }

    dispatchEvent(payload) {
        // if (payload.type === "auth_response") {
        //     this.dispatchRegisterInstance();
        //     return;
        // }
        if (payload.type === "batch") {
            payload.data.forEach((d) => {
                try {
                    let acc = d.action || d.type;

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'VISION') {

                        this.comm.api.gb.emitters.emit.game.suspendGame();

                        var modal = new Modal( this.comm.api, d.data.messageContent, () => {
                            this.comm.api.gb.emitters.emit.game.resumeGame();
                        });

                        //open modal popup
                        modal.showModal();
                        return;
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'POKERSTARS') {
                        window.postMessage({'integration_player_notifications': d.module, 'walletProviderCode': d.data.walletProviderCode, ...d.data.messageContent}, '*')

                        return;
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'PLAYTECH') {
                        this.comm.api.gb.emitters.emit.game.updateBalance({balance: d.data.messageContent.balance});

                        return;
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'LNWOGS') {
                        if (d.data.messageContent.messageId && d.data.messageContent.messageId === 'lnwOgsPlayerBalance') {
                            //call js library method to display balance
                            if (this.comm.api.gb.wallet) {
                                this.comm.api.gb.wallet.tmpBalance = {
                                    realBalance: d.data.messageContent.realBalance,
                                    bonusBalance: d.data.messageContent.bonusBalance,
                                    lastUpdated: new Date()
                                };

                                if (!this.setTmpBalanceInterval) {
                                    this.setTmpBalanceInterval = setInterval(() => {
                                        if (this.comm.api.gb.wallet && !this.comm.api.gb.isSpinning) {
                                            this.comm.api.gb.wallet.balanceChange(this.comm.api.gb.wallet.tmpBalance.realBalance, this.comm.api.gb.wallet.tmpBalance.bonusBalance);
                                            clearInterval(this.setTmpBalanceInterval);
                                            this.setTmpBalanceInterval = null;
                                        }
                                    }, 150);
                                }
                                // this.comm.api.gb.wallet.balanceChange(d.data.messageContent.realBalance, d.data.messageContent.bonusBalance);
                            }
                            return;
                        } else if (d.data.messageContent.messageId && d.data.messageContent.messageId === 'lnwOgsError') {
                            //call js library method to display error message
                            if (this.comm.api.gb.wallet) {
                                // errorCode comes as empty string so it needs to take the value of errorRcCode
                                if (d.data.messageContent && d.data.messageContent.errorRcCode !== undefined) {
                                    d.data.messageContent.errorCode = d.data.messageContent.errorRcCode;
                                }
                                this.comm.api.gb.wallet.handleCustomError(d.data.messageContent.errorCategory, d.data.messageContent.errorSeverity, d.data.messageContent.errorCode, d.data.messageContent.errorMessage);
                            }
                            return;
                        } else if (d.data.messageContent.messageId && d.data.messageContent.messageId === 'lnwOgsPlayerNotification') {
                            //call js library method to display CMA message
                            if (this.comm.api.gb.wallet) {
                                this.comm.api.gb.wallet.callHandleMessageTrigger(atob(d.data.messageContent.details));
                            }
                            return;
                        } else {
                            logger.debug("Unknown message id", d.data.messageContent.messageId);
                        }
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.source === 'integration.detailed.message.client.superwheel') {
                        var message =  {
                            "title": "",
                            "body": "",
                            "prohibitGameplay": false
                        };
                        switch (d.data.messageContent.errorCode) {
                            case "BET_DENIED":
                                //OutOfMoney, GamingLimitsReached - errors that depend on player balance/status
                                switch(this.comm.api.gb.settings.languageCode) {
                                    case "NL":
                                    case "NLD":
                                    case "DUT":
                                        message.title = "Geen geld meer";
                                        message.body = "U heeft uw maximale saldolimiet bereikt. Uw inzet is te hoog. Verlaag uw inzet, schakel SUPER WHEEL™ uit of stort geld op uw spelersrekening.";
                                        break;
                                    default:
                                        message.title = "Out of money";
                                        message.body = "You have reached your maximum balance limit. Your bet is too high. Please lower your bet, disable SUPER WHEEL™, or deposit money into your account.";
                                }
                                break;
                            case "WALLET_ERROR":
                                //All rest wallet errors - when wallet did not receive SW bet
                                switch(this.comm.api.gb.settings.languageCode) {
                                    case "NL":
                                    case "NLD":
                                    case "DUT":
                                        message.title = "Fout";
                                        message.body = "Er is een fout opgetreden, uw SUPER WHEEL™-weddenschap is niet geaccepteerd.";
                                        break;
                                    default:
                                        message.title = "Error";
                                        message.body = "An error occurred, your SUPER WHEEL™ bet has not been accepted.";
                                }
                                break;
                            default:
                                break;
                        }

                        var modal = new Modal( this.comm.api, message, () => {
                            if (d.data.messageContent.errorCode === 'BET_DENIED') {
                                this.comm.api.modules.superWheel.deactivateWheel();
                            }
                        });

                        //open modal popup
                        modal.showModal();
                        return;
                    }

                    if (d.data && (d.module === '"integration_player_notifications"' || d.instance === 'integration_player_notifications') && d.data.walletProviderCode === 'LOTTOLAND') {
                        if(d.data.messageContent.messageId && d.data.messageContent.messageId === 'lottolandPlayerNotification' || true) {
                            d.data.messageContent.details.body = d.data.messageContent.details.content;
                            d.data.messageContent.details.prohibitGameplay = false;


                            var modal = new Modal( this.comm.api, d.data.messageContent.details, () => {});

                            //open modal popup
                            modal.showModal();
                            return;
                        }
                    }

                    if (d.type === 'playerAction_response') {
                        acc =  d.action.toLowerCase();
                    }
                    if (d.error) {
                        this.comm.registeredInstances[`${d.module}_${d.instance}`].status = "ERROR";
                    } else if (d.data && d.data.status) {
                        this.comm.registeredInstances[`${d.module}_${d.instance}`].status = d.data.status;
                    }

                    if (acc === "instanceAvailable") {
                        this.comm.api.modules.initiateInstance(d);
                        return;
                    }

                    if (d.data && (d.module === "stakelogic_superwheel" && d.type === "update")) {
                        if (d.data.loggerLevel) {
                            this.api.gb.setLoggerLevel(d.data.loggerLevel, true);
                        }

                        if(d.action==="initialLoad") {
                            this.comm.api.modules.superWheel.initialLoadReceived = true;
                            this.comm.api.modules.superWheel.historyLink = d.data.historyLink;
                            this.comm.api.modules.superWheel.feedsLink = d.data.feedsLink;
                            this.comm.api.modules.superWheel.hitRate = d.data.hitRate;
                            this.comm.api.modules.superWheel.setPlatform(d.data.deviceType);
                            this.comm.api.modules.superWheel.promotedFeature = d.data.promotedFeature;
                            this.comm.api.modules.superWheel.sideBetAmount = d.data.sideBetAmount;
                            this.comm.api.modules.superWheel.sideBetCalculationType = d.data.sideBetCalculationType;
                            this.comm.api.modules.superWheel.initWheel();

                            //start keep alive messages
                            this.comm.api.modules.superWheel.startKeepAlive();
                            if(d.data.raffles && d.data.raffles.length > 0) {
                                const delay = this.comm.api.modules.superWheel.showTeaser(true);
                                setTimeout(() => {
                                    this.comm.api.modules.superWheel.addRaffles(d.data.raffles);
                                    this.comm.api.modules.superWheel.startNextRound();
                                }, delay);
                            }

                            if(d.data.buttonState) {
                                this.comm.api.modules.superWheel.changeSwButtonState(true);
                            } else {
                                this.comm.api.modules.superWheel.changeSwButtonState(false);
                            }

                            if(d.data.sideBetCalculationType && d.data.sideBetAmount) {
                                this.comm.api.modules.superWheel.sideBetCalculationType = d.data.sideBetCalculationType;

                                if(d.data.sideBetAmount>0) {
                                    this.comm.api.modules.superWheel.sideBetAmount = d.data.sideBetAmount;
                                }
                                this.comm.api.modules.superWheel.updateTotalBet();
                            }
                        }

                        if (d.action==="newRaffle") {
                            const delay = this.comm.api.modules.superWheel.showTeaser(true);
                            setTimeout(() => {
                                this.comm.api.modules.superWheel.addRaffles([d.data.raffle]);
                                this.comm.api.modules.superWheel.startNextRound();
                            }, delay);
                        }
                        return;
                    }

                    window.dispatchEvent(new CustomEvent(`oryx_${d.module.toLowerCase()}_${d.instance}_${acc.toLowerCase()}`, {"detail": d}));
                } catch (e) {
                    // console.error(e);
                    // normal flow ... some push msg dont have module, instance, ... they do not need to be dispatched
                }
            });
        } else {
            if (payload.type === "instanceAvailable") {

                this.comm.api.modules.initiateInstance(payload);
                return;
            }

            if (payload.type === null && payload.error) {
                if (payload.error.message) {
                    logger.debug("No api decoder", payload.error.message);
                }

                return;
            } else if (payload.error) {
                if (payload.error.message) {
                    logger.debug("Agg front error", payload.error.message);
                }

                return;
            }

            if (payload.type === "player_properties") {
                window.dispatchEvent(new CustomEvent(`oryx_${payload.type}`, {"detail": payload}));

                return;
            }

            //console.log("Socket message", `oryx_${payload.module.toLowerCase()}_${payload.instance}_${payload.type === 'playerAction_response' ? payload.action.toLowerCase() : payload.type.toLowerCase()}`, payload);
            window.dispatchEvent(new CustomEvent(`oryx_${payload.module.toLowerCase()}_${payload.instance}_${payload.type === 'playerAction_response' ? payload.action.toLowerCase() : payload.type.toLowerCase()}`, {"detail": payload}));
        }
    }

    // dispatchRegisterInstance() {
    //     window.dispatchEvent(new CustomEvent(`oryx_register_instance`));
    // }

}
